module.exports = __webpack_public_path__ + "img/icon-1-1.e5e314b2.png";